// ProgressBar.jsx
export default function ProgressBar({ props }) {
  const { maxMarks, totalMarksObtained } = props;
  const percentage = (totalMarksObtained / maxMarks) * 100;

  return (
    <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
      <div
        className={`h-full rounded-full transition-all duration-500 ${
          percentage >= 75
            ? "bg-green-500"
            : percentage >= 50
            ? "bg-yellow-500"
            : "bg-red-500"
        }`}
        style={{ width: `${percentage}%` }}
      ></div>
    </div>
  );
}
